import React from "react"
import classnames from "classnames"
import * as layouts from "layouts"
import * as inputs from "inputs"
import * as icons from "icons"
import * as api from "brandguard/api"
import * as bglayouts from "brandguard/components/layouts"
import { splitLines } from "brandguard/display/brandguard/text/components/dropwell"
import { acceptedMimetypes, assetTypeForFile } from "./types"

const acceptedTypes: Record<string, string[]> = Object.assign({}, ...Object.values(acceptedMimetypes))

interface props extends layouts.containers.ContainerProps {
	onChange(item: File[]): void
	disabled?: boolean
}

// Dropwell accepts every mimetype the four typed pickers accept. Text files are
// split into per-line assets exactly as the text picker does; everything else
// is handed on as dropped and uploadFile routes each by its detected type.
function Dropwell(props: React.PropsWithChildren<props>): JSX.Element {
	const { onChange, disabled, ...rest } = props
	const onDropHandle = (acceptedFiles: File[]) => {
		const direct: File[] = []
		acceptedFiles.forEach((f) => {
			if (assetTypeForFile(f) === "text") splitLines(f).then(onChange)
			else direct.push(f)
		})
		if (direct.length > 0) onChange(direct)
	}

	return (
		<inputs.Dropwell
			className="any.dropwell"
			accept={acceptedTypes}
			onDrop={(accepted) => onDropHandle(accepted)}
			flex="1"
			multiple
			disabled={disabled}
			{...rest}
		>
			<layouts.dnd.Container>
				<icons.FileUpload className="dropwell-icon" />
				<layouts.dnd.Textual>Drag & drop images, text, PDFs or videos here or choose files</layouts.dnd.Textual>
			</layouts.dnd.Container>
		</inputs.Dropwell>
	)
}

export default function Upload(
	props: React.PropsWithChildren<
		{
			background: string
			observation: api.Prediction
		} & inputs.uploads.api.Props
	>,
): JSX.Element {
	const { children, background, observation, onChange } = props

	return (
		<>
			<Dropwell
				className={classnames(
					"any",
					"upload",
					bglayouts.uploads.navdropwellsimple,
					observation === api.Prediction.REJECTED
						? `${bglayouts.uploads.navdropwellred} ${bglayouts.uploads.navareared}`
						: "",
				)}
				mb="20px"
				onChange={(files) => onChange(files, background)}
			/>
			{children}
		</>
	)
}
